import { app } from '../../../app';

app.factory('PinReset', PinReset);

/** @ngInject */
function PinReset($resource) {
    return $resource('app/rest/smsGenerateOtp/resetPin', {}, {
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/public/pin-reset/pin-reset.service.js